// extracted by mini-css-extract-plugin
export default {"indicatorWrapper":"ChartIndicator_indicatorWrapper__RvLso"};